import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import ReactTable from 'react-table';
import { t } from '../../../../../modules/infra/i18n';

import UserType from '../Shared/userType';
import ImpersonateUser from '../../../shared/ImpersonateUser';

const BarbersList = ({ users, shopId }) => (
  <div style={{ marginLeft: '34px' }}>
    <ReactTable
      className="c-table-new c-no-hover"
      data={users}
      minRows={0}
      showPagination={false}
      resizable={false}
      defaultPageSize={10000}
      columns={[
        {
          Header: t('admin:users.list.username_header'),
          accessor: 'username',
          className: 'u-text-center',
        },
        {
          Header: t('admin:users.list.kind_header'),
          accessor: user => user,
          id: 'userType',
          className: 'u-text-center',
          Cell: row => <UserType user={row.value} />,
        },
        { // used for sorting only
          Header: t('admin:users.list.kind_header'),
          accessor: user => user,
          id: 'kind',
          show: false,
          sortMethod: (a, b) => {
            if (a.brand || b.brand) return -1;
            if (a.kind === b.kind) return 0;
            return a.kind > b.kind ? 1 : -1;
          },
        },
        {
          Header: t('admin:users.list.name_header'),
          accessor: 'name',
          id: 'name',
          className: 'u-text-center',
        },
        {
          Header: t('admin:users.list.actions_header'),
          accessor: user => user,
          id: 'actions',
          className: 'u-text-center',
          width: 100,
          sortable: false,
          Cell: row => (
            <span>
              <Link className="u-co-primary u-type--bold" to={`/admin/users/${row.value.id}`}>{t('admin:users.list.edit_action')}</Link>
              <br />
              <ImpersonateUser id={row.value.id} shopId={row.value.brand ? null : shopId} />
            </span>
          ),
        },
      ]}
      defaultSorted={[
        {
          id: 'kind',
          desc: true,
        },
      ]}
    />
  </div>
);

BarbersList.propTypes = {
  users: PropTypes.array,
  shopId: PropTypes.string.isRequired,
};

BarbersList.defaultProps = {
  users: [],
};

export default BarbersList;
